import { MarketCodeLabel } from '@homesusa/core';
import { KpiType } from '../enums';
import { KpiRequests } from '../interfaces/kpi';

export const calculateKpiData = (kpiData: KpiRequests[], type: KpiType) => {
  const filteredData = kpiData.filter((item: KpiRequests) => item.type === type);

  const total = filteredData.reduce((acc: number, item: KpiRequests) => acc + item.total, 0);

  const details = filteredData
    .map((item: KpiRequests) => `${MarketCodeLabel.get(item.market)}: ${item.total}`)
    .sort()
    .join('<br/>');

  return { total, details };
};
